// extracted by mini-css-extract-plugin
export default {"language_wrapper":"styles_language_wrapper__YDI09"};